export default {
    data: function() {
        return {
            payArray: [
                {
                    label: "未结算",
                    value: 0
                },
                {
                    label: "已结算",
                    value: 1
                },
                {
                    label: "仅出库",
                    value: 2
                }
            ],
            resaleTypeArray: [
                {
                    label: "图片代卖",
                    value: 2
                },
                {
                    label: "实物代卖",
                    value: 3
                },
                {
                    label: "图片+实物代卖",
                    value: 4
                },
            ],
            downloadStatusArray: [
                {
                    label: "准备中",
                    value: 0
                },
                {
                    label: "压缩中",
                    value: 1
                },
                {
                    label: "已完成",
                    value: 2
                },
                {
                    label: "失败",
                    value: 3
                },
            ],
            productStatusArray: [
                {
                    label: "入库",
                    value: 1
                },
                {
                    label: "图片代卖",
                    value: 2
                },
                {
                    label: "实物代卖",
                    value: 3
                },
                {
                    label: "图片+实物代卖",
                    value: 4
                },
                {
                    label: "已锁定",
                    value: 5
                },
                {
                    label: "出库",
                    value: 6
                }
            ],
            logTypeArray: [
                {
                    label: "入库",
                    value: 1
                },
                {
                    label: "图片代卖",
                    value: 2
                },
                {
                    label: "实物代卖",
                    value: 3
                },
                {
                    label: "图片+实物代卖",
                    value: 4
                },
                {
                    label: "已锁定",
                    value: 5
                },
                {
                    label: "出库",
                    value: 6
                },
                {
                    label: "退回",
                    value: 7
                },
                {
                    label: "删除图片代卖",
                    value: 8
                },
                {
                    label: "删除实物代卖",
                    value: 9
                },
                {
                    label: "更新价格",
                    value: 10
                },
                {
                    label: "撤销出库",
                    value: 11
                },
                {
                    label: "更新出品人",
                    value: 12
                },
                {
                    label: "更新库存地",
                    value: 13
                }
            ]
        }
    },
    methods: {
        getPayName: function (pay) {
            for (let i = 0; i < this.payArray.length; i++) {
                if (this.payArray[i].value == pay) {
                    return this.payArray[i].label;
                }
            }
            return "";
        },
        getResaleTypeName: function(status) {
            let name = "";
            for (let i = 0; i < this.resaleTypeArray.length; i++) {
                if (this.resaleTypeArray[i].value == status) {
                    name = this.resaleTypeArray[i].label;
                    break;
                }
            }
            return name;
        },
        getProductStatusName: function(status) {
            let name = "";
            for (let i = 0; i < this.productStatusArray.length; i++) {
                if (this.productStatusArray[i].value == status) {
                    name = this.productStatusArray[i].label;
                    break;
                }
            }
            return name;
        },
        getLogTypeName: function(status) {
            let name = "";
            for (let i = 0; i < this.logTypeArray.length; i++) {
                if (this.logTypeArray[i].value == status) {
                    name = this.logTypeArray[i].label;
                    break;
                }
            }
            return name;
        },
        getDownloadStatusName: function(status) {
            let name = "";
            for (let i = 0; i < this.downloadStatusArray.length; i++) {
                if (this.downloadStatusArray[i].value == status) {
                    name = this.downloadStatusArray[i].label;
                    break;
                }
            }
            return name;
        }
    },
    created: function() {
        
    }
}